import { Grid } from "@mui/material";
import React from "react";
import SplashLogo from "../../Assets/openzl_logo/landingPage_logo.png";

const SplashScreen = () => {
  return (
    <Grid
      lg={12}
      display={"flex"}
      flexDirection={"row"}
      className="splash_page p-0 m-0"
    >
      <img className="img-fluid tagline" src={SplashLogo} alt={"SplashLogo"} />
    </Grid>
  );
};

export default SplashScreen;
